import { render, staticRenderFns } from "./SectionButtons.vue?vue&type=template&id=02021fd2&scoped=true&"
import script from "./SectionButtons.vue?vue&type=script&lang=js&"
export * from "./SectionButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02021fd2",
  null
  
)

export default component.exports